// Polyfills
import 'es6-object-assign/auto';
import 'core-js/fn/array/includes';
import 'core-js/fn/promise/finally';
import 'intl'; // For Safari 9

import React from 'react';
import ReactDOM from 'react-dom';

import AppStateHOC from '../lib/app-state-hoc.jsx';
import BrowserModalComponent from '../components/browser-modal/browser-modal.jsx';
import supportedBrowser from '../lib/supported-browser';
import AccessGate from '../coding-board/gate/AccessGate.jsx';
import CreditsPage from '../coding-board/credits/CreditsPage.jsx';

import styles from './index.css';

const appTarget = document.createElement('div');
appTarget.className = styles.app;
document.body.appendChild(appTarget);

// Renders the real Studio (or the unsupported-browser modal) imperatively
// into appTarget. Called directly on /credits-less, gate-less navigation,
// and via AccessGate's onUnlock once the beta password is accepted.
const renderStudio = () => {
    if (supportedBrowser()) {
        // require needed here to avoid importing unsupported browser-crashing code
        // at the top level
        require('./render-gui.jsx').default(appTarget);

    } else {
        BrowserModalComponent.setAppElement(appTarget);
        const WrappedBrowserModalComponent = AppStateHOC(BrowserModalComponent, true /* localesOnly */);
        const handleBack = () => {};
        // eslint-disable-next-line react/jsx-no-bind
        ReactDOM.render(<WrappedBrowserModalComponent onBack={handleBack} />, appTarget);
    }
};

if (window.location.pathname === '/credits') {
    // /credits stays reachable without the beta password — it's the AGPL
    // Section 13 source-code notice and must be publicly accessible.
    ReactDOM.render(<CreditsPage />, appTarget);
} else {
    // eslint-disable-next-line react/jsx-no-bind
    ReactDOM.render(
        <AccessGate onUnlock={renderStudio}>
            <div className={styles.app} />
        </AccessGate>,
        appTarget
    );
}
